import { render, staticRenderFns } from "./CompetitionsList.vue?vue&type=template&id=67e9cd0a&"
import script from "./CompetitionsList.vue?vue&type=script&lang=js&"
export * from "./CompetitionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports